import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'report-detail',
  data: function () {
    return {
      utils:      utils,
      facilityId: null, // 施設ID（クリニックID、介護支援事業所ID）
      patientId:  null, // 患者ID
      reportId:   null, // 報告書ID
      restartDate: null, // 再送信日
      restartTime: null, // 再送信時
      searchCallbackFlag: false, // 検索結果フラグ
      type: null, // 施設・医療機関タイプ ※報告書送信履歴からの遷移時に指定されます
    }
  },

  created: function() {
    // システム管理者 または 薬剤師
    this.$store.dispatch('USER_ADMIN_PHARMACIST')

    this.facilityId = this.$route.params['facilityId']
    this.patientId  = this.$route.params['patientId']
    this.reportId   = this.$route.params['reportId']
    this.type        = this.$route.params['type']
    this.search()
  },
  mounted () {
    // ヘルプボタン表示
    utils.helpModalShow()
  },
  computed: {
    // /** トークン */
    // authToken() {
    //   return window.localStorage.getItem('access_token')
    // },
    /** 報告書 */
    report () {
      if (this.$store.getters.report === null) {
        return null
      }
      var report = this.$store.getters.report
      report['taking_start_method_name'] = this.getMethodName(report['taking_start_method'])  // -/朝/昼/夕/就寝前
      report['taking_end_method_name']   = this.getMethodName(report['taking_end_method'])    // -/朝/昼/夕/就寝前
      report['deli_start_method_name']   = this.getMethodName(report['deli_start_method'])    // -/朝/昼/夕/就寝前
      report['deli_end_method_name']     = this.getMethodName(report['deli_end_method'])      // -/朝/昼/夕/就寝前
      report['taking_status_name']      = this.getFailureGood(report['taking_status'])        // 服薬状況 (不良/良)
      report['condition_change_name']   = this.getAriNashi(report['condition_change'])        // 体調変化 (無/有)
      report['remnant_status_name']     = this.getAriNashi(report['remnant_status'])          // 残薬状況 (無/有)
      report['interaction_name']        = this.getAriNashi(report['interaction'])             // 相互作用 (無/有)
      report['take_interaction_name']   = this.getAriNashi(report['take_interaction'])        // 服用薬と相互作用のある飲食物の摂取 (無/有)
      report['complication_name']       = this.getAriNashi(report['complication'])            // 他科受診、合併症 (無/有)
      report['other_dosage_name']       = this.getAriNashi(report['other_dosage'])            // 他科からの投薬 (無/有)
      report['otc_combination_name']    = this.getAriNashi(report['otc_combination'])         // ＯＴＣの併用 (無/有)
      report['last_request_name']       = this.getAriNashi(report['last_request'])            // 後発品の希望 (無/有)
      report['visit_duty_name']         = this.getAriNashi(report['visit_duty'])              // 義務照会 (無/有)
      report['dispense_idea_name']      = this.getAriNashi(report['dispense_idea'])           // 調剤上の工夫 (無/有)
      report['side_effect_status_name'] = this.getAriNashi(report['side_effect_status'])      // 副作用発見(無/有)
      report['medicine_notebook_name']  = this.getAriNashi(report['medicine_notebook'])       // 薬手帳(無/有)
      return report
    },
    /** 送信中止可能な状態 */
    isReportSendCancelable () {
      return this.$store.getters.reportSendCancelable
    },
    /** 送信再開可能な状態 */
    isReportSendReStartable () {
      return this.$store.getters.reportSendReStartable
    },
    /** 患者情報 */
    patient () {
      return this.$store.getters.reportPatient
    },
    /** 計画書 */
    plan () {
      return this.$store.getters.reportPlan
    },
    /** 存在チェック */
    reportExists () {
      return this.$store.getters.reportExists
    },
    /** システム管理者 または 薬剤師 */
    isAdminOrPharmacist() {
      return this.$store.getters.userAdminOrPharmacist
    },
    /** システム管理者 または 組織長かつ薬剤師 */
    isAdminOrPharmacistManager() {
      return this.$store.getters.userAdminOrPharmacistManager
    },
    /** 通知 */
    notify () {
      if (this.$store.getters.reportEditNotify !== null) {
        return this.$store.getters.reportEditNotify
      }
      return this.$store.getters.reportNotify
    },
    /** 通知 報告書送信 */
    reportSendNotify () {
      return this.$store.getters.reportSendNotify
    },
    /** 日付一括必須チェック */
    requiredRestart () {
      return {
        restartDate:        !this.restartDate,
        restartDate_format: !utils.isWareki(this._self.$t, this.restartDate),
        restartTime:        !this.restartTime,
      }
    },
    /** 必須チェック、和暦チェック */
    isRestartComplete () {
      var req  = this.requiredRestart
      var result = true
      // 必須
      for (var key in req) {
        if (req[key]) {
          result = false
          break
        }
      }
      return result
    },
    /** apiローディング */
    loading () {
      return this.$store.getters.apiLoading
    },
    /** 報告書送信履歴からの遷移 */
    isReportSend () {
      return utils.isPresent(this.type)
    },
    nsUsage () {
      return this.$store.getters.nsUsage
    }
  },

  methods: {
    /** 編集ボタン */
    search: function () {
      var self = this
      this.searchCallbackFlag = false
      var callback = function() {
        self.searchCallbackFlag = true
      }
      this.$store.dispatch('REPORT_MEDICINE_SEARCH', {data: {report_id: this.reportId}})
      this.$store.dispatch('REPORT_SEARCH', {reportId: this.reportId, data: {patient_id: this.patientId}, callback: callback})
    },
    /** 編集ボタン */
    onClickReportEdit: function () {
      if (this.isReportSend) {
        this.$router.push({path: '/reports/send/' + this.type + '/' + this.facilityId + '/' + this.patientId + '/' + this.reportId + '/edit', query: {type: this.$router.currentRoute.query.type}})
      } else {
        this.$router.push({path: '/nsips/reports/' + this.facilityId + '/' + this.patientId + '/' + this.reportId + '/edit'})
      }
    },
    /** 削除ボタン */
    onClickDeleteReport: function () {
      this.$store.dispatch('REPORT_DELETE',{
        reportId:    this.reportId,
        data:        {
          'patient_id': this.patientId
        },
        callback:    this.onDeleteReportCallback,
        loadparams: 'block'
      })
    },
    onDeleteReportCallback: function (data) {
      this.goPrev(false)
    },
    /**
     * PDF出力ボタン
     * @param clinic_send_check     クリニック 送付方法
     * @param careoffice_send_check 介護支援事業所 送付方法
     */
    onClickPdf: function(clinic_send_check, careoffice_send_check) {
      var send_to = 0
      var pdf_header = 1
      if (clinic_send_check) send_to = constant.send_to.doctor
      if (careoffice_send_check) send_to = constant.send_to.careman
      if (clinic_send_check && careoffice_send_check) send_to = constant.send_to.renmei
      // 薬歴
      if (this.isReportTypeYakureki(this.report)) {
        pdf_header = 0
        if (clinic_send_check === '' && careoffice_send_check === '') {
          send_to = ''
        }
      }

      var reportId = this.reportId
      var data = { 'report_id': reportId, 'pdf_header': pdf_header, 'send_to': send_to }
      var self = this
      var callback = function (data) {
        var link = document.getElementById('print_download_link')
        link.setAttribute('download', data.url)
        link.href = data.url
        link.click()
        // ファイル削除
        self.$store.dispatch('REPORT_REMOVE_PDF', {data:{download_id: data.download_id}, callback: (data) => {}, loadparams: 'block'})
      }
      this.$store.dispatch('REPORT_PDF', {data: data, callback: callback, loadparams: 'block'})
    },
    /** 患者検索に戻る */
    goPatientsList: function () {
      this.$router.push({ path: '/patients/list/', query: {'keep': 'true'}})
    },
    /** 前画面に戻る */
    goPrev: function (keep) {
      if (this.isReportSend) {
        /** 報告書送信履歴に戻る 削除の場合キープせずに再検索 */
        if (keep) {
          this.$router.push({ path: '/reports/history/' + this.type + '/' + this.facilityId, query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
        } else {
          this.$router.push({ path: '/reports/history/' + this.type + '/' + this.facilityId, query: {type: this.$router.currentRoute.query.type}})
        }
      } else {
        /** 報告書検索ページに戻る 削除の場合キープせずに再検索 */
        if (keep) {
          this.$router.push({ path: '/patients/report/' + this.facilityId + '/' + this.patientId, query: {'keep': 'true'}})
        } else {
          this.$router.push({ path: '/patients/report/' + this.facilityId + '/' + this.patientId})
        }
      }
    },
    /** 施設検索等に戻る */
    goReportHistoryList: function () {
      if (this.type === 'facility') {
        this.$router.push({path: '/facilities', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.type === 'facility_person') {
        this.$router.push({path: '/facility_persons', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.type === 'clinic') {
        this.$router.push({path: '/clinics', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      } else if (this.type === 'care_office') {
        this.$router.push({path: '/care_offices', query: {type: this.$router.currentRoute.query.type, keep: 'true'}})
      }
    },
    /**
     * 再送信
     * @param to_type : clinic クリニック 送付方法 , careoffice 介護支援事業所 送付方法
     */
    onClickReSend: function (to_type) {
      var data = {
        'report_id': this.reportId,
        'to_type':   constant.send_to[to_type], // doctor:医師 または careman:ケアマネージャー
      }
      this.$store.dispatch('REPORT_RE_SEND', {data: data, callback: this.reSendCallback})
    },
    /** 再送信コールバック */
    reSendCallback: function (params) {
      this.search()
    },

    /** 送信停止 */
    onClickCancelSend: function () {
      var data = {
        'report_id': this.reportId,
      }
      this.$store.dispatch('REPORT_SEND_CANCEL', {data: data, callback: this.cancelSendCallback})
    },
    /** 送信停止コールバック */
    cancelSendCallback: function (params) {
      this.search()
    },

    /** 送信再開モーダル表示 */
    onClickShowModalRestartSend: function () {
      this.restartDate = utils.sereki2Wareki(this.$t, new Date())
      this.restartTime = constant.report.default_time // '7:00'
      var button = document.getElementById('restart_modal_button')
      button.click() // モーダル表示 イベント発火
    },
    /** 送信再開 */
    onClickRestartSend: function () {
      var date = utils.wareki2Seireki(this.$t, this.restartDate, 'y-m-d')
      var time = this.restartTime
      var data = {
        'report_id':          this.reportId,
        'reserved_send_time': date + ' ' + time,
      }
      this.$store.dispatch('REPORT_SEND_RESTART', {data: data, callback: this.restartSendCallback})
    },
    /** 送信再開コールバック */
    restartSendCallback: function (params) {
      this.search()
    },

    /** 報告書種類が 医師に提出 対象確認 */
    isReportTypeClinicSendCheck: function (report) {
      if (report === null) {
        return false
      }
      if (report.clinic_send_check !== 1) {
        return false
      }
      if (this.isReportTypeClinic(report)) {
        return true
      }
      return false
    },
    /** 報告書種類が 医師に提出 対象確認 */
    isReportTypeClinicSend: function (report) {
      if (report === null) {
        return false
      }
      if (report.clinic_send_check !== 1 && this.isReportTypeClinic(report)) {
        return true
      }
      return false
    },
    /** 報告書種類が 医師に提出 対象確認 */
    isReportTypeClinic: function (report) {
      if (report === null) {
        return false
      }
      if (
        report['report_type'] === constant.report.report_type.kyotaku       || // 居宅療養管理指導
        report['report_type'] === constant.report.report_type.yakuzai_kanri || // 在宅患者訪問薬剤管理指導
        report['report_type'] === constant.report.report_type.yaku_shidou   || // かかりつけ薬剤師指導
        report['report_type'] === constant.report.report_type.yaku_houkatsu    // かかりつけ薬剤師包括管理
      ) {
        return true
      }
      return false
    },
    /** 報告書種類が ケアマネに提出 管理対象確認 */
    isReportTypeCareofficeSendCheck: function (report) {
      if (report === null) {
        return false
      }
      if (report.careoffice_send_check !== 1) {
        return false
      }
      if (this.isReportTypeCareoffice(report)) {
        return true
      }
      return false
    },
    /** 報告書種類が ケアマネに提出 管理対象確認 */
    isReportTypeCareofficeSend: function (report) {
      if (report === null) {
        return false
      }
      if (report.careoffice_send_check !== 1 && this.isReportTypeCareoffice(report)) {
        return true
      }
      return false
    },
    /** 報告書種類が ケアマネに提出 管理対象確認 */
    isReportTypeCareoffice: function (report) {
      if (report === null) {
        return false
      }
      if (
        report['report_type'] === constant.report.report_type.kyotaku       || // 居宅療養管理指導
        report['report_type'] === constant.report.report_type.yaku_shidou   || // かかりつけ薬剤師指導
        report['report_type'] === constant.report.report_type.yaku_houkatsu    // かかりつけ薬剤師包括管理
      ) {
        return true
      }
      return false
    },
    /** 報告書種類が薬歴 */
    isReportTypeYakureki: function (report) {
      if (report === null) {
        return false
      }
      // 薬歴
      if (report['report_type'] === constant.report.report_type.yakureki) {
        return true
      }
      return false
    },

    /*******************************************************
     * 値取得
     ******************************************************/
    /** 有/無を取得 */
    getAriNashi: function (idx) {
      if (idx !== null) {
        return this.$t('report.ari_nashi')[idx]
      }
      return ''
    },
    /** 不良/良を取得 */
    getFailureGood: function (idx) {
      if (idx !== null) {
        return this.$t('report.failure_good')[idx]
      }
      return ''
    },
    /** '－', '朝', '昼', '夕', '就寝前'を取得 */
    getMethodName: function (id) {
      if (id !== null) {
        var list = this.$t('report.method_name')
        var name = ''
        for (var i = 0; i < list.length; i++) {
          if (utils.str2int(list[i].id)  === utils.str2int(id)) {
            name = list[i].text
            break
          }
        }
        return name
      }
      return ''
    },
    /** 名称リストを取得 */
    getNameList: function (key) {
      return this.$t(key)
    },
    goMedicinesDetail: function(yjCode){
      // 薬情報を開く
      var url = location.href
      var div = this.$router.currentRoute.path
      var path = url.substring(0, url.indexOf(div) + 1) + 'medicines/' + yjCode
      var win = window.open(path, 'window_sub_medicines')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/report-detail.js